import { ApsListFilter } from './filterDoctors';
import { DoctorGroup } from './groupCandidatesByDoctor';
import { ApsSource } from './types';
import { compareVisitDatesDesc } from './visitDateUtils';

const APS_SOURCE_BUCKET_ORDER: ApsSource[] = [
  'Disclosure',
  'Dx',
  'Rx',
  'PreviouslyOrdered',
];

export const sortDoctorGroupsByVisitDate = (
  groups: DoctorGroup[],
): DoctorGroup[] =>
  [...groups].sort((a, b) =>
    compareVisitDatesDesc(a.lastVisitDate, b.lastVisitDate),
  );

/** Disclosure → Dx → Rx → Previously Ordered, sorted by visit date within each. */
export const sortDoctorGroupsBySourceBuckets = (
  groups: DoctorGroup[],
): DoctorGroup[] =>
  APS_SOURCE_BUCKET_ORDER.flatMap(source =>
    sortDoctorGroupsByVisitDate(groups.filter(g => g.source === source)),
  );

/**
 * Sort groups for an APS list filter. Call after `filterDoctors` — groups are
 * already scoped to the active source tab when filter !== 'All'.
 */
export const sortDoctorGroupsForFilter = (
  groups: DoctorGroup[],
  filter: ApsListFilter,
): DoctorGroup[] => {
  if (filter === 'All') {
    return sortDoctorGroupsBySourceBuckets(groups);
  }
  if (filter === 'PreviouslyOrdered') {
    return groups;
  }
  return sortDoctorGroupsByVisitDate(groups);
};
